import JsonViewer from 'vue-json-viewer';

export default {
  props: ['titulo', 'mensaje', 'tipo', 'callback', 'details', 'detailsHtml', 'withDetailButton'],
  components: { JsonViewer },
  name: 'Alert',
  methods: {
    cancel() {
      this.$bvModal.hide('alert-modal');
      if (this.callback) {
        this.callback();
      }
    },
    validateNeedButton() {
      if (this.withDetailButton === undefined || this.withDetailButton === null || this.withDetailButton === true) {
        return true;
      }
      return false;
    },
  },
  computed: {
    clases() {
      const base = ['btn', 'width-button', 'margin-buttons', 'border-button'];
      if (this.tipo && this.tipo === 'error') {
        base.push('btn-danger');
      } else {
        base.push('btn-primary');
      }
      return base.join(' ');
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      this.$destroy(); // cleanup in component
      this.$el.remove();
    });
  },
};
